import React from 'react';
import { GuestRegistryState } from '../../GuestRegistry.controller';
import { useShoppingCart } from '@apps/registry/common/components/ShoppingCart/state';
import { ExpressCheckout } from '@apps/registry/common/components/ExpressCheckout/ExpressCheckout';

export interface CartCheckoutProps {
  eventHandle: string;
  eventId: string;
  registryState: GuestRegistryState;
}

export const CartCheckout = (props: CartCheckoutProps) => {
  const {
    state: { itemList }
  } = useShoppingCart();
  return <ExpressCheckout {...props} purchaseItems={itemList} />;
};
